
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartLegend, ChartLegendContent } from '@/components/ui/chart';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';

const sustainabilityData = [
  { month: 'Jan', certified: 12, pending: 8, rejected: 2 },
  { month: 'Feb', certified: 18, pending: 6, rejected: 1 },
  { month: 'Mar', certified: 25, pending: 10, rejected: 3 },
  { month: 'Apr', certified: 32, pending: 5, rejected: 2 },
  { month: 'May', certified: 41, pending: 8, rejected: 1 },
  { month: 'Jun', certified: 48, pending: 12, rejected: 4 }
];

const chartConfig = {
  certified: {
    label: 'Certified',
    color: '#22c55e'
  },
  pending: {
    label: 'Pending',
    color: '#f59e0b'
  },
  rejected: {
    label: 'Rejected',
    color: '#ef4444'
  }
};

export const SustainabilityChart = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Product Certification Progress</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={sustainabilityData}>
              <XAxis dataKey="month" />
              <YAxis />
              <ChartTooltip content={<ChartTooltipContent />} />
              <ChartLegend content={<ChartLegendContent />} />
              <Bar dataKey="certified" fill="var(--color-certified)" />
              <Bar dataKey="pending" fill="var(--color-pending)" />
              <Bar dataKey="rejected" fill="var(--color-rejected)" />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
